import { memo } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { cx } from '@trinity/chat-components';
import styles from './style/Skeleton.module.css';

type Props = {
  className?: string;
  rows: number;
};

export const Summary = memo((props: Props) => {
  return (
    <div className={cx(styles.summary, props.className)}>
      {Array.from({ length: props.rows }).map((_, i) =>
        <Row key={i} />)}
    </div>
  );
});

Summary.displayName = 'Transcript.Skeleton.Summary';

const Row = memo((props: unknown) => {
  return (
    <div className={styles.row}>
      <Skeleton
        variant="text"
        sx={{ fontSize: '16px', lineHeight: '30px', width: '150px' }} />
      <Skeleton variant="text" sx={{ fontSize: '16px', lineHeight: '28px', width: '90%' }} />
      <Skeleton variant="text" sx={{ fontSize: '16px', lineHeight: '28px' }} />
      <Skeleton variant="text" sx={{ fontSize: '16px', lineHeight: '28px', width: '45%' }} />
    </div>
  );
});

Row.displayName = 'Transcript.Skeleton.Summary.Row';